module.exports = __webpack_public_path__ + "img/Porsche-dwgs2-lnk-7-crop.de267b0d.png";